import { Base64 } from "js-base64";

export * from "./api";

export function openAllLinksInNewTab(rootShadowRoot: ShadowRoot | null, activate: boolean) {
  if (rootShadowRoot == null) {
    return;
  }

  const elements = rootShadowRoot.querySelectorAll("a");
  elements.forEach(function (element) {
    const targetValue = activate ? "_blank" : "_self";
    element.setAttribute("target", targetValue);
  });
}

/**
 * Takes a base64 encoded data string and returns a decoded object.
 * @param dataStr
 */
export function decodeData<D>(dataStr: string): D {
  const decoded = Base64.decode(dataStr);
  return JSON.parse(decoded);
}

/**
 * Takes a string and checks whether it is a valid email address
 * @param email
 * @returns boolean
 */
export function isEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/**
 * Checks if the current device is a mobile device via media query.
 */
export function isMobileDevice(): boolean {
  // Based on media query for mobile devices instead of a user agent strategy as media query is a more robust solution and user agents can be spoofed.
  // Note: This matches our tailwind config as being < sm.
  return window.matchMedia("screen and (max-width: 639px)").matches;
}

const webViewRegex = /webview|wv|ip((?!.*Safari)|(?=.*like Safari))/i;
export function isWebView(): boolean {
  try {
    const userAgent = navigator.userAgent || "";
    return webViewRegex.test(userAgent);
  } catch (error) {
    return false;
  }
}
